import { formatPlaceName } from '@aviv_price-pages/brand';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
export const usePageTitle = (place, isDuplicatePlaceName) => {
    const { t } = useShellTranslation();
    return t(`page_h1.${place.type}`, {
        replace: { place: formatPlaceName(place, { withProvince: isDuplicatePlaceName }) },
        unsafe_escapeValue: false,
    });
};
